import React from "react";
import { Message, Transition } from "semantic-ui-react";
import { SemanticCOLORS } from "semantic-ui-react/dist/commonjs/generic";
import "../../styles/ui.scss";

interface IBCValidationMessage {
  invalidProps: string[];
  prop: string;
  color?: SemanticCOLORS;
  onDismiss?: any;
  propText?: string;
}

const BCValidationMessage = ({ ...props }: IBCValidationMessage) => {
  return (
    <Transition
      animation={props.invalidProps.length === 0 ? "scale" : "shake"}
      duration={{hide: 10, show: 500}}
      visible={props.invalidProps.includes(props.prop)}
    >
      {props.invalidProps.includes(props.prop) ? <Message 
        className="gmr-message" 
        negative color={props.color ? props.color : "red"}
        onDismiss={props.onDismiss}
      >
        {props.propText ? props.propText : "This field is required."}
      </Message> : <div/>}
    </Transition>
  );
};

export default BCValidationMessage;
